import React from "react";

import { Box, ColorMode, FadeWrapper, Wrapper } from "components";

import Content from "./Content";
import LargeGraphic from "./LargeGraphic";
import ScrollButton from "./ScrollButton";
import SmallGraphic from "./SmallGraphic";

const CONTENT_MAX_WIDTH = 580;

function HomeHero({ hero_image, headline, scroll_prompt }) {
  return (
    <ColorMode mode="dark">
      <Box bg="brand.primary">
        <Wrapper
          data-component-id="homeHero"
          position="relative"
          zIndex={2}
          overflow="visible"
        >
          <LargeGraphic image={hero_image} offset={CONTENT_MAX_WIDTH} />
          <SmallGraphic image={hero_image} />
          <FadeWrapper delay={0.2}>
            {headline && headline.text && (
              <Content
                title={headline.text}
                subtitle={scroll_prompt}
                maxWidth={CONTENT_MAX_WIDTH}
              />
            )}
          </FadeWrapper>
          <ScrollButton />
        </Wrapper>
      </Box>
    </ColorMode>
  );
}

export default HomeHero;
